import { displayTz } from "@/lib/prefs";

export const STATS = ["pts", "reb", "ast", "fg3m", "pra"];
export const STAT_LABEL = { pts: "PTS", reb: "REB", ast: "AST", fg3m: "3PM", pra: "PRA" };

export const n1 = (v) => (v == null || Number.isNaN(v) ? "–" : Number(v).toFixed(1));
export const n2 = (v) => (v == null || Number.isNaN(v) ? "–" : Number(v).toFixed(2));
export const pct = (v) => (v == null ? "–" : `${(v * 100).toFixed(1)}%`);

const athens = { timeZone: "Europe/Athens" };

export function athensDate(offsetDays = 0) {
  const d = new Date(Date.now() + offsetDays * 86400000);
  return d.toLocaleDateString("en-CA", athens);
}

// The NBA "slate day" — the US Eastern date the backend groups games under (game_day). The day rolls over at ~5:00 AM
// ET (well after the latest west-coast game ends), so late-night viewers keep seeing the slate that is still live
// instead of jumping to the next morning's games when their own local midnight passes.
export function nbaToday(offsetDays = 0) {
  const t = new Date(Date.now() - 5 * 3600 * 1000 + offsetDays * 86400000);
  return t.toLocaleDateString("en-CA", { timeZone: "America/New_York" });
}

export function tipoff(iso) {
  return new Date(iso).toLocaleTimeString("en-GB", { timeZone: displayTz(), hour: "2-digit", minute: "2-digit" });
}

export function shortDate(day) {
  return new Date(`${day}T12:00:00Z`).toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

export function dateTime(iso) {
  return new Date(iso).toLocaleString("en-GB", { timeZone: displayTz(), day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}
